import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const k = {
    header: "domains.application.components.main-layout.main-layout-i18n.header",
    footer: "domains.application.components.main-layout.main-layout-i18n.footer",
    signOut: "domains.application.components.main-layout.main-layout-i18n.signOut",
    settings: "domains.application.components.main-layout.main-layout-i18n.settings",
    support: "domains.application.components.main-layout.main-layout-i18n.support",
    about: "domains.application.components.main-layout.main-layout-i18n.about"
};
export const translations = {
    da: {
        header: "Unik Advosys",
        footer: "© {{aar}}",
        signOut: "Log af",
        settings: "Indstillinger",
        support: "Support",
        about: "Om Advosys"
    },
    en: {
        header: "Unik Advosys",
        footer: "© {{aar}}",
        signOut: "Sign out",
        settings: "Settings",
        support: "Support",
        about: "About Advosys"
    }
};
export const useT = () => {
    const { t, i18n } = useTranslation();
    const localT = useMemo(() => ({
        header: t(k.header),
        footer: t(k.footer),
        signOut: t(k.signOut),
        settings: t(k.settings),
        support: t(k.support),
        about: t(k.about)
    }), [i18n.language]);
    return useMemo(() => ({ t: localT, i18n }), [localT, i18n]);
};
